import React from 'react';

const Sitting = (props) => (
    <svg viewBox="0 0 500 500" width={34} height={34}>
        <circle fill={props.color || '#000'} cx="196.13" cy="118.27" r="38.06"/>
        <polygon fill={props.color || '#000'} points="332.5,383.5 332.5,260.5 252.85,260.5 234.92,172.56 234.92,170.3 157.13,170.3 157.13,173.56 176.92,269.6 186.13,314.28 272.98,314.28 272.98,383.79 317.5,383.79 332.5,383.79 "/>
    </svg>
);

export default Sitting;